// src/components/Modal.jsx

export default function Modal({ isOpen, onClose, title, children, footer, width = "w-96" }) {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      style={{ backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)' }}
    >
      <div 
        className={`bg-white rounded-lg p-6 ${width} max-h-96 overflow-y-auto`}
        style={{ boxShadow: '0 0 50px rgba(0, 0, 0, 0.3)' }}
      >
        <h2 className="text-xl font-semibold mb-4">{title}</h2>
        <div>{children}</div>
        {footer && <div className="mt-4">{footer}</div>}
      </div>
    </div>
  );
}
